export default __webpack_public_path__ + "static/media/COMPAS.b817d300.jpg";